import { A as Appearance } from './enums.js';
import { V as VividElement, a as attr } from './vivid-element.js';
import { H as HostSemantics } from './host-semantics.js';
import { O as Orientation } from './aria.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const DividerRole = {
  /**
   * The divider semantically separates content
   */
  separator: "separator",
  /**
   * The divider has no semantic value and is for visual presentation only.
   */
  presentation: "presentation"
};
class Divider extends HostSemantics(VividElement) {
  constructor() {
    super(...arguments);
    this.role = DividerRole.separator;
    this.orientation = Orientation.horizontal;
    this.appearance = Appearance.Ghost;
  }
}
__decorateClass([
  attr
], Divider.prototype, "role");
__decorateClass([
  attr
], Divider.prototype, "orientation");
__decorateClass([
  attr
], Divider.prototype, "appearance");

export { Divider as D, DividerRole as a };
